import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getTokenLocalStorage } from '../config/tokenManager';
import { getUsuario } from '../services/usuario';
import { toast } from 'react-toastify';
import { getAtendimentos } from '../services/atendimento';
import constantes from '../config/constantes';
import { addDays } from '../helpers/dateHelper';
import { Dialog } from '@mui/material';
import PopupMarcaVocal from '../components/PopupMarcaVocal/PopupMarcaVocal';

export const MainContext = React.createContext(null);

export function useMain() {
    return React.useContext(MainContext);
}

export function MainProvider({ children }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [token, setToken] = React.useState(getTokenLocalStorage());
    const [usuario, setUsuario] = React.useState(null);
    const [globalIsRecording, setGlobalIsRecording] = React.useState(false);
    const [atendimentos, setAtendimentos] = React.useState([]);
    const [inIFrame, setInIFrame] = React.useState(false);
    const [popUpGravaMarcaVocal, setPopupGravaMarcaVocal] = React.useState(false);
    const [marcaVocal, setMarcaVocal] = React.useState(null);
    const carregaUsuario = useCallback(async () => {
        if (token) {
            try {
                const usuario = await getUsuario();
                setUsuario(usuario);
            } catch (error) {
                console.error(error);
                if (error.response.status === 401) {
                    location.navigate('/login');
                }
            }
        } else {
            setUsuario(null);
            setToken(null);
        }
    }, [token]);

    // useEffect(() => {
    //     if (usuario) {
    //         const jsonMarcavocal = localStorage.getItem(`${constantes.audioMarcaVocal}${usuario.id}`);
    //         if (!jsonMarcavocal) {
    //             setPopupGravaMarcaVocal(true);
    //         } else {
    //             const marcavocal = JSON.parse(jsonMarcavocal);
    //             if (!marcavocal || addDays(new Date(marcavocal.dataGravacao), 3) < new Date()) {
    //                 {
    //                     setPopupGravaMarcaVocal(true);
    //                 }
    //             }
    //         }
    //     }
    // }, [usuario]);

    async function carregaAtendimentos() {
        try {
            const atendimentos = await getAtendimentos();
            setAtendimentos(atendimentos.sort((a, b) => new Date(b.dataCriacao) - new Date(a.dataCriacao)));
        } catch (error) {
            console.error(error);
            toast.error('Erro ao carregar atendimentos');
        }
    }

    useEffect(() => {
        if (!token) {
            toast.error('Você não está logado');
            navigate('/login', { replace: true, state: { from: location.pathname, ...location.state } });
        } else {
            carregaUsuario();
            carregaAtendimentos();
        }
    }, [token, location]);

    return (
        <MainContext.Provider
            value={{
                token,
                carregaUsuario,
                usuario,
                globalIsRecording,
                setGlobalIsRecording,
                atendimentos,
                carregaAtendimentos,
                inIFrame,
                setInIFrame,
                setPopupGravaMarcaVocal,
                popUpGravaMarcaVocal,
            }}
        >
            {children}

            <PopupMarcaVocal
                onClose={() => setPopupGravaMarcaVocal(false)}
                open={popUpGravaMarcaVocal}
                onOpen={() => setPopupGravaMarcaVocal(true)}
            />
        </MainContext.Provider>
    );
}
